// src/pages/SwimLessons.jsx
import CourseSchedule from '../components/CourseSchedule';

const sessions = [
  {
    title: "Kids Level 1–3",
    date: "Ongoing Monthly",
    time: "Saturdays, 10am–12pm",
    location: "North York Pool",
    price: 100
  },
  {
    title: "Adult Learn-to-Swim",
    date: "July 2 – July 23, 2025",
    time: "Tues & Thurs, 6pm–7pm",
    location: "Etobicoke Swim Centre",
    price: 120
  }
];

const SwimLessons = () => (
  <div className="bg-white text-gray-900 font-sans">
    <section className="pt-32 pb-16 px-6 max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold mb-6 text-blue-800">Swim Lessons for All Ages</h1>
      <p className="text-lg mb-4">
        No matter your age or skill level, we offer personalized swim lessons designed for everyone...
      </p>
    </section>

    <CourseSchedule sessions={sessions} />
  </div>
);

export default SwimLessons;
